import React from 'react';

const currentYear = new Date().getFullYear();

function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__content">
                    <p className="footer__text">
                        Aleksandr Sorokin © {currentYear} — Built with React.
                    </p>
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <a
                            href="https://www.linkedin.com/in/aleksandr-sorokin-631a24265/"
                            className="footer__link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            LinkedIn
                        </a>
                        <a
                            href="https://github.com/jarrald"
                            className="footer__link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            GitHub
                        </a>
                        <a
                            href="https://www.flaticon.com/free-icons/api"
                            className="footer__link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Icons by Flaticon
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;